import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOJsonLD from '@/components/base/SEOJsonLD';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedVideos from './components/FeaturedVideos';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "红桃tv - 高清视频娱乐平台官方入口",
  "description": "红桃tv是深受用户喜爱的高清视频娱乐平台，提供海量影视、综艺、直播内容，随时随地畅享优质视听体验。",
  "url": "https://hongtaotv.com/",
  "isPartOf": {
    "@type": "WebSite",
    "name": "红桃tv",
    "url": "https://hongtaotv.com/"
  }
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    { "@type": "Question", "name": "红桃tv是否需要注册才能观看？", "acceptedAnswer": { "@type": "Answer", "text": "部分内容支持免注册观看，但注册成为红桃tv会员后，可以享受更多高清内容、无广告播放、专属推荐等增值服务。注册过程简单快捷，支持手机号一键注册。" } },
    { "@type": "Question", "name": "红桃tv支持哪些设备观看？", "acceptedAnswer": { "@type": "Answer", "text": "红桃tv全面支持手机（iOS/Android）、平板、电脑网页端、智能电视（TV版）等多种设备。一个账号，多端同步，随时随地畅享高清视频。" } },
    { "@type": "Question", "name": "红桃tv的视频画质如何？卡不卡？", "acceptedAnswer": { "@type": "Answer", "text": "红桃tv采用先进的流媒体传输技术，支持1080P、4K超高清画质播放。智能码率自适应算法会根据您的网络状况自动调整，确保流畅不卡顿的观看体验。" } },
    { "@type": "Question", "name": "红桃tv的内容更新频率如何？", "acceptedAnswer": { "@type": "Answer", "text": "我们与国内外多家内容方深度合作，电视剧、综艺等热门内容基本做到同步更新。电影和纪录片也在持续扩充中，每天都有新内容上线。" } },
    { "@type": "Question", "name": "如何下载红桃tv APP？", "acceptedAnswer": { "@type": "Answer", "text": "您可以在苹果App Store或各大安卓应用市场搜索红桃tv下载官方APP。也可以在官网首页点击下载APP按钮，扫描二维码直接下载。" } },
    { "@type": "Question", "name": "红桃tv的最新地址是什么？", "acceptedAnswer": { "@type": "Answer", "text": "红桃tv官方唯一域名是 hongtaotv.com（示例），请认准官方网站。建议收藏本站或关注官方公众号获取最新动态，避免访问到仿冒网站。" } }
  ]
};

export default function Home() {
  return (
    <>
      <SEOJsonLD data={homeSchema} />
      <SEOJsonLD data={faqSchema} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedVideos />
        <LatestArticles />
        <FAQSection />

        <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14 text-center">
          <div className="bg-primary-500/5 border border-primary-200/50 rounded-xl p-8 md:p-12">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 bg-primary-100 rounded-full flex items-center justify-center">
              <i className="ri-download-2-line text-primary-500 text-2xl md:text-3xl"></i>
            </div>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-3">
              立即下载红桃tv APP
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-6 max-w-lg mx-auto leading-relaxed">
              随时随地畅享高清视频，海量内容一触即达。支持iOS和Android双平台。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a href="#" className="px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-md text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer" rel="nofollow">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </a>
              <a href="#" className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer" rel="nofollow">
                <i className="ri-android-fill text-lg"></i>
                安卓版下载
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}